var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMounted)?_c('ErrorBoundary',[(_vm.selectedLayoutType)?_c('div',{staticClass:"fe-w-full fe-spacing"},[_c('LayoutSelector',{attrs:{"layout-type":_vm.selectedLayoutType,"binding-type":_vm.bindingType}}),_c('ModalRegistry'),_c('ToastRegistry')],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }